import { IconSvg, IconSvgProps } from "./icon"

export default function CircleCheck(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path
        d="M12 20.364A8.357 8.357 0 1 0 12 3.65a8.357 8.357 0 0 0 0 16.714Z"
        data-slot="circle"
      />
      <path d="m8.276 12.687 2.039 2.543 5.343-6.518" data-slot="check" />
    </IconSvg>
  )
}
